/* unplugin-vue-components disabled */import { render } from "./QuestionRandomizer.vue?vue&type=template&id=492c3ef2&scoped=true"
import script from "./QuestionRandomizer.vue?vue&type=script&lang=js"
export * from "./QuestionRandomizer.vue?vue&type=script&lang=js"

import "./QuestionRandomizer.vue?vue&type=style&index=0&id=492c3ef2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/wheretoeat/wheretoeat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492c3ef2"]])

export default __exports__